import { render, staticRenderFns } from "./AddressForm.vue?vue&type=template&id=525005ba&scoped=true"
import script from "./AddressForm.vue?vue&type=script&lang=ts"
export * from "./AddressForm.vue?vue&type=script&lang=ts"
import style0 from "./AddressForm.vue?vue&type=style&index=0&id=525005ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "525005ba",
  null
  
)

export default component.exports